import { A11yModule } from "@angular/cdk/a11y";
import { ClipboardModule } from "@angular/cdk/clipboard";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { PortalModule } from "@angular/cdk/portal";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { CdkStepperModule } from "@angular/cdk/stepper";
import { CdkTableModule } from "@angular/cdk/table";
import { CdkTreeModule } from "@angular/cdk/tree";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatBadgeModule } from "@angular/material/badge";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatNativeDateModule, MatRippleModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSliderModule } from "@angular/material/slider";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatStepperModule } from "@angular/material/stepper";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatTreeModule } from "@angular/material/tree";
import { CheckboxElementComponent } from "@app/erp/components/form-elements/checkbox-element/checkbox-element.component";
import { DropdownElementComponent } from "@app/erp/components/form-elements/dropdown-element/dropdown-element.component";
import { NumberElementComponent } from "@app/erp/components/form-elements/number-element/number-element.component";
import { TextElementComponent } from "@app/erp/components/form-elements/text-element/text-element.component";
import { AdvancedOfficeEmployeeDropdownComponent } from "@app/shared/modules/form-components/advanced-office-employee-dropdown/advanced-office-employee-dropdown.component";
import { AdvancedOfficeEmployeeDropdownService } from "@app/shared/modules/form-components/advanced-office-employee-dropdown/advanced-office-employee-dropdown.service";
import { FormComponentsModule } from "@app/shared/modules/form-components/form-components.module";
import { UiComponentsModule } from "@app/shared/modules/ui-components/ui-components.module";
import { UtilModule } from "@app/shared/modules/util/util.module";
import { NgxErrorsModule } from "@ngspot/ngx-errors";
import { TranslateModule } from "@ngx-translate/core";
import { MomentModule } from "angular2-moment";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { DateElementComponent } from "./date-element/date-element.component";
import { ElementWrapperComponent } from "./element-wrapper/element-wrapper.component";
import { ForeignGeoDataDropdownsComponent } from "@app/shared/modules/form-components/foreign-geo-data-dropdowns/foreign-geo-data-dropdowns.component";

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    MomentModule,
    UtilModule,
    TooltipModule,
    UiComponentsModule,
    FormComponentsModule,
    NgxErrorsModule,
    BsDropdownModule,
    A11yModule,
    ClipboardModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    DragDropModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    PortalModule,
    ScrollingModule,
    MatFormFieldModule,
    BsDropdownModule,
  ],
  declarations: [
    TextElementComponent,
    NumberElementComponent,
    ElementWrapperComponent,
    CheckboxElementComponent,
    DropdownElementComponent,
    DateElementComponent,
    AdvancedOfficeEmployeeDropdownComponent,
    ForeignGeoDataDropdownsComponent,
  ],
  exports: [
    TextElementComponent,
    NumberElementComponent,
    ElementWrapperComponent,
    CheckboxElementComponent,
    DropdownElementComponent,
    DateElementComponent,
    AdvancedOfficeEmployeeDropdownComponent,
    ForeignGeoDataDropdownsComponent,
  ],
  providers: [AdvancedOfficeEmployeeDropdownService],
})
export class ErpFormElementsModule {}
